/* eslint-disable quotes */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect, useState } from 'react';
import { Alert, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Paper, Snackbar, SnackbarCloseReason, TextField } from '@mui/material';
import * as yup from 'yup';
import { Checkbox, FormControlLabel } from "@mui/material";
import { ProdutosService, IListagemDeReferencias } from "../../../shared/services/api/estoque/produtos/ProdutosService";
import { IVFormErrors, useVForm, VFieldMoney, VForm, VTextField, VTextFieldData } from '../../../shared/forms';

interface IFormData {
  idref: string;
  referencia: string;
  original: boolean;
}

export interface ConfirmationDialogRawProps {
  id: string;
  idref: string;
  dados?: IFormData;
  value: string;
  open: boolean;
  onClose: (value?: string) => void;
}

const FeriasSchema = yup.object().shape({
  referencia: yup.string().required(),
  original: yup.boolean().required().default(false),
});

export const DialogAlterarReferencia: React.FC<ConfirmationDialogRawProps> = (props: ConfirmationDialogRawProps) => {
  const { formRef, save } = useVForm();
  const { onClose, value: valueProp, open, idref, ...other } = props;
  const [value, setValue] = useState(valueProp);
  const [isLoading, setIsLoading] = useState(false);
  const [id, setId] = useState('');
  const [openmsg, setOpenmsg] = useState(false);
  const [msg, setMsg] = useState('');
  const [isOriginal, setIsOriginal] = useState(false);
  const [tms, setTms] = useState<'warning' | 'error' | 'info' | 'success'>('warning');

  const handleCloseMsg = (
    event?: React.SyntheticEvent | Event,
    reason?: SnackbarCloseReason,
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenmsg(false);
    if (tms === 'success') {
      resetForm();
      onClose();
    }
  };
  useEffect(() => {
    if (open) {
      if (!props.dados) {
        resetForm();
      }
    }
  }, [open]);
  const resetForm = () => {
    formRef.current?.setData({
      referencia: '',
      original: false,
    });

    setIsOriginal(false);
  };

  useEffect(() => {
    if (props.dados && typeof props.dados === 'object') {
      formRef.current?.setData(props.dados);
    }
  }, [id]);
  useEffect(() => {
    if (props.dados) {
      setIsOriginal(props.dados.original);
    }
  }, [props.dados]);

  const handleCancel = () => {
    resetForm();
    onClose();
  };

  useEffect(() => {
    if (!open) {
      setValue(valueProp);
    } else {
      setId(valueProp);
    }
  }, [valueProp, open]);

  const handleSave = (dados: IFormData) => {

    const dadosComOriginal = {
      ...dados,
      original: isOriginal,
    };

    FeriasSchema.validate(dadosComOriginal, { abortEarly: false })
      .then((dadosValidados) => {
        setIsLoading(true);
        if (idref === 'novo') {
          ProdutosService.createreferencia(props.id, dadosValidados)
            .then((result) => {
              setIsLoading(false);
              if (result instanceof Error) {
                setTms('error');
                setMsg(result.message);
                setOpenmsg(true);
              } else {
                setTms('success');
                setMsg('Lançamento Realizado com sucesso!');
                setOpenmsg(true);
              }
            });
        } else if (idref !== 'novo') {
          const dadosComIdProduto = {
            ...dadosValidados,
            idproduto: props.id,
          };
          ProdutosService.updateByIdReferencia(idref, dadosComIdProduto)
            .then((result) => {
              setIsLoading(false);

              if (result instanceof Error) {
                setTms('error');
                setMsg(result.message);
                setOpenmsg(true);
              } else {
                setTms('success');
                setMsg('Lançamento realizado com sucesso!');
                setOpenmsg(true);
              }
            });
        }

      })
      .catch((errors: yup.ValidationError) => {
        const validationErrors: IVFormErrors = {};
        errors.inner.forEach(error => {
          if (!error.path) return;
          validationErrors[error.path] = error.message;
        });
        formRef.current?.setErrors(validationErrors);
      });
  };

  return (
    <Dialog
      open={open}
      {...other}
    >
      <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={openmsg} autoHideDuration={900} onClose={handleCloseMsg}>
        <Alert
          onClose={handleCloseMsg}
          severity={tms}
          variant="filled"
          sx={{ width: '100%' }}
        >
          {msg}
        </Alert>
      </Snackbar>
      <DialogTitle>Alterar Referência</DialogTitle>
      <DialogContent dividers>
        <VForm ref={formRef} onSubmit={handleSave}placeholder={undefined} onPointerEnterCapture={undefined}onPointerLeaveCapture={undefined}>
          <Box display="flex" padding={3} gap={1} component={Paper} variant="outlined">
            <Grid container marginTop={1} item direction="row" spacing={1.5} >
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Grid container item direction="row" spacing={1.5}>

                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <VTextField
                      fullWidth
                      size='small'
                      name='referencia'
                      label='Referência'
                      disabled={isLoading}
                    />

                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={isOriginal}
                          onChange={(e) => setIsOriginal(e.target.checked)}
                        />
                      }
                      label="Referência original"
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Box>
        </VForm>
      </DialogContent>
      <DialogActions>
        <Button size='small' sx={{ minWidth: '30%' }} variant='outlined' onClick={handleCancel}>Voltar</Button>
        <Button size='small' sx={{ minWidth: '30%' }} variant='contained' onClick={save}>Alterar</Button>
      </DialogActions>
    </Dialog>
  );
}; 